import { render } from "./UserChatLogListPage.vue?vue&type=template&id=9451ad96"
import script from "./UserChatLogListPage.vue?vue&type=script&lang=js"
export * from "./UserChatLogListPage.vue?vue&type=script&lang=js"
script.render = render

export default script